module.exports = __webpack_public_path__ + "img/systemnotify.6b7f4bd6.png";